import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_LIST_API_ID,
  ({ userId }) => ({
    endpoint: `/api/admin/users/${userId}/identification-images`,
    method: 'GET',
  })
);

export default apiCall;
